import React, { forwardRef } from 'react'
import { Button, DialogueBox } from 'components/UIElements'
import { closeIcon, downloadIcon } from '../../../assets/assets'

const ConsentInProgressView = forwardRef(
  ({
    renderContent,
    strings,
    disableConsentButton,
    onConsent,
    onConsentDecline,
    error,
    shouldShowNextButton,
    shouldShowBackButton,
    nextButtonDisabled,
    backButtonDisabled,
    downloadConsentPDF,
    consentName,
    isBlockingConsent,
    isReadOnlyConsent,
    onConsentClose,
    onConsentRead,
    isConsentAlreadyRead,
    onNextButtonClick,
    onBackButtonClick,
    onScroll,
    contentRef,
    consentId,
    consentVersion
  }, _ref) => {
    return (
      <DialogueBox className='dialogue no-humi'>
        <div className='top-section-buttons'>
          <div
            className='top-section-icon'
            onClick={() => {
              downloadConsentPDF(consentName, consentVersion, consentId)
            }

            }>
            {downloadIcon()}
          </div>
          {!isBlockingConsent ? (
            <div className='top-section-icon' onClick={onConsentClose}>
              {closeIcon()}
            </div>
          ) : null}
        </div>

        <div className='consent-content' ref={contentRef} onScroll={onScroll}>
          {renderContent()}
        </div>

        <div className='bottom-section'>
          <div className='response-buttons'>
            {isReadOnlyConsent ? (
              <Button
                primary
                className={`keep-padding primary-button ${isConsentAlreadyRead ? 'disabled-grey' : ''
                  }`}
                content={
                  isConsentAlreadyRead
                    ? 'Consent Read'
                    : 'I have read the consent'
                }
                disabled={isConsentAlreadyRead}
                onClick={onConsentRead}
              />
            ) : !shouldShowNextButton ? (
              <>
                <Button
                  primary
                  className={`keep-padding primary-button ${disableConsentButton ? 'disabled-grey' : ''
                    }`}
                  content={strings.agree}
                  disabled={disableConsentButton}
                  onClick={onConsent}
                />
                <Button
                  className='decline-btn secondary-button keep-padding'
                  content={strings.do_not_agree}
                  secondary
                  onClick={onConsentDecline}
                />
              </>
            ) : null}
          </div>

          <div className='navigation-buttons'>
            {shouldShowBackButton ? (
              <Button
                className={`keep-padding ${disableConsentButton && !shouldShowNextButton ? 'primary-button' : 'secondary-button'} ${backButtonDisabled ? 'disabled-grey' : ''
                  }`}
                content={'Back'}
                disabled={backButtonDisabled}
                onClick={onBackButtonClick}
                icon='fa fa-chevron-up'
              />
            ) : null}

            {shouldShowNextButton ? (
              <Button
                className={`keep-padding ${!disableConsentButton ? 'secondary-button' : 'primary-button'
                  } ${nextButtonDisabled ? 'disabled-grey' : ''}`}
                content={'Next'}
                disabled={nextButtonDisabled}
                onClick={onNextButtonClick}
                icon='fa fa-chevron-down'
              />
            ) : null}
          </div>
        </div>

        {error && <p className='error-msg'>{error}</p>}
      </DialogueBox>
    )
  }
)

export default ConsentInProgressView
